import { createRouter, createWebHistory } from 'vue-router'
import { nextTick } from 'vue'
import { store } from '../store/store'
import axios from 'axios'
import { resetAppScroll } from '../helpers/scrollToTop'

import register from '@/components/registration/register'
import Login from '@/components/authentication/login'
import forgotpassword from '@/components/authentication/forgot'
import verify from '@/components/authentication/verify'
import confirmEmail from '@/components/authentication/confirm-email'
import quotelist from '@/components/quote/list/list'
import MainQuote from '@/components/quote/main/main'
import Contact from '@/components/contact/contact'
import CustomerNew from '@/views/customer/New'
import CustomerEdit from '@/views/customer/Edit'
import AccountSetting from '@/components/setting/account/account'
import DiscountForm from '@/views/settings/DiscountForm'
import ProductForm from '@/views/settings/ProductForm'
import TaskForm from '@/views/settings/TaskForm'
import UserForm from '@/views/settings/UserForm'
import SelectAccount from '@/views/auth/SelectAccount'
import InviteAccept from '@/views/invite/Accept'
import DisplaySetting from '@/components/setting/display/display'
import Help from '@/components/help/help'
import about from '@/components/about/about'
import Terms from '@/components/terms/terms'
import Privacy from '@/components/privacy/privacy'
// import Product from '@/components/product/product' // Deprecated - use material component instead
import Task from '@/components/task/task'
import material from '@/components/material/material'
import category from '@/components/category/category'
import setup from '@/components/account/setup'
import accept from '@/components/quote/accept/accept'
import invoiceApprove from '@/components/invoice/approve/approve'
import resetpassword from '@/components/authentication/password'
import plan from '@/components/setting/plan/plan'
import payment from '@/components/setting/payment/payment'
import invoice from '@/views/invoice/Listing';
import ServiceM8Callback from '@/views/integrations/servicem8/Callback';
import OnboardingLayout from '@/views/onboarding/Layout';
import OnboardingWelcome from '@/views/onboarding/Welcome';
import OnboardingJobSettings from '@/views/onboarding/JobSettings';
import OnboardingPlan from '@/views/onboarding/Plan';
import OnboardingPayment from '@/views/onboarding/Payment';
import OnboardingComplete from '@/views/onboarding/Complete';
import EmailPreviews from '@/views/EmailPreviews';
import NotFound from '@/views/NotFound';
import { captureReferralFromQuery } from '@/helpers/referral'

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior (to, from, savedPosition) {
    // Vue Router 4 uses { top, left }; keep resetAppScroll for nested overflow roots
    if (savedPosition) {
      resetAppScroll(savedPosition)
      return savedPosition
    }
    return new Promise((resolve) => {
      nextTick(() => {
        resetAppScroll()
        resolve({ top: 0, left: 0 })
      })
    })
  },
  routes: [
    {
      path: '/',
      name: 'Quotes',
      component: quotelist,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/quote/new',
      name: 'NewQuote',
      component: MainQuote,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/quote/:id',
      name: 'LoadQuote',
      component: MainQuote,
      props: {default: true},
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/invoice',
      name: 'Invoices',
      component: invoice,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/category',
      name: 'CategorySettings',
      component: category,
      meta: { requiresAuth: true, adminOnly: true }
    },
    {
      path: '/contact',
      name: 'Contacts',
      component: Contact,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/customer/new',
      name: 'CustomerNew',
      component: CustomerNew,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/customer/:id',
      name: 'CustomerEdit',
      component: CustomerEdit,
      props: true,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/account',
      name: 'AccountSettings',
      component: AccountSetting,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/discount/new',
      name: 'DiscountNew',
      component: DiscountForm,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/discount/:id',
      name: 'DiscountEdit',
      component: DiscountForm,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/user/new',
      name: 'UserNew',
      component: UserForm,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/user/:id',
      name: 'UserEdit',
      component: UserForm,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/select-account',
      name: 'SelectAccount',
      component: SelectAccount,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/invite/accept/:token',
      name: 'InviteAccept',
      component: InviteAccept,
      meta: { requiresAuth: false }
    },
    {
      path: '/settings/display',
      name: 'DisplaySettings',
      component: DisplaySetting,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/product/new',
      name: 'ProductNew',
      component: ProductForm,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/product/:id',
      name: 'ProductEdit',
      component: ProductForm,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/product',
      name: 'ProductSettings',
      component: material, // Use material component - "Products" is just user-facing terminology
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/task/new',
      name: 'TaskNew',
      component: TaskForm,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/task/:id',
      name: 'TaskEdit',
      component: TaskForm,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/task',
      name: 'TaskSettings',
      component: Task,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/material',
      name: 'MaterialSettings',
      component: material,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/account/setup/:token',
      name: 'setup',
      component: setup,
      meta: { requiresAuth: false }
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: { requiresAuth: false }
    },
    {
      path: '/verify',
      name: 'verify',
      component: verify,
      meta: { requiresAuth: false }
    },
    {
      path: '/confirm-email',
      name: 'confirmEmail',
      component: confirmEmail,
      meta: { requiresAuth: false }
    },
    {
      path: '/forgotpassword',
      name: 'forgotpassword',
      component: forgotpassword,
      meta: { requiresAuth: false }
    },
    {
      path: '/password/reset/:token',
      name: 'resetpassword',
      component: resetpassword,
      meta: { requiresAuth: false }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: { requiresAuth: false }
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
      meta: { requiresAuth: false }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      meta: { requiresAuth: false }
    },
    {
      path: '/email-previews',
      name: 'EmailPreviews',
      component: EmailPreviews,
      meta: { requiresAuth: false }
    },
    {
      path: '/quote/accept/:uuid',
      name: 'Accept',
      component: accept,
      meta: { requiresAuth: false }
    },
    {
      path: '/invoice/approve/:uuid',
      name: 'InvoiceApprove',
      component: invoiceApprove,
      meta: { requiresAuth: false }
    },
    {
      path: '/settings/plans',
      name: 'plans',
      component: plan,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/settings/payment',
      name: 'payment',
      component: payment,
      meta: { requiresAuth: true, adminOnly: false }
    },
    {
      path: '/integrations/servicem8/oauth/callback',
      name: 'servicem8-oauth',
      component: ServiceM8Callback,
      meta: { requiresAuth: false }
    },
    {
      path: '/onboarding',
      component: OnboardingLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          redirect: '/onboarding/welcome'
        },
        {
          path: 'welcome',
          name: 'OnboardingWelcome',
          component: OnboardingWelcome
        },
        {
          path: 'job-settings',
          name: 'OnboardingJobSettings',
          component: OnboardingJobSettings
        },
        {
          path: 'plan',
          name: 'OnboardingPlan',
          component: OnboardingPlan
        },
        {
          path: 'payment',
          name: 'OnboardingPayment',
          component: OnboardingPayment
        },
        {
          path: 'complete',
          name: 'OnboardingComplete',
          component: OnboardingComplete
        }
      ]
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFound,
      meta: { requiresAuth: false }
    }
  ]
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  captureReferralFromQuery(to.query)

  // If login is in progress, allow all navigation
  if (store.getters['user/isLoginInProgress']) {
    console.log('🔐 Navigation guard: Login in progress, allowing navigation to:', to.path)
    next()
    return
  }

  // Xero OAuth return on /?xero=... (backup if main.js normalize did not run). Only from root path —
  // never strip query from /settings/account?xero=...
  const readXeroOAuth = () => {
    if (to.query && to.query.xero) {
      return {
        xero: String(to.query.xero),
        tab: (to.query.tab && String(to.query.tab)) || 'integrations',
        message: to.query.message ? String(to.query.message) : ''
      }
    }
    if (typeof window !== 'undefined' && window.location.search) {
      const sp = new URLSearchParams(window.location.search)
      const x = sp.get('xero')
      if (!x) return null
      return {
        xero: x,
        tab: sp.get('tab') || 'integrations',
        message: sp.get('message') || ''
      }
    }
    return null
  }
  const oauth = readXeroOAuth()
  if (oauth && (to.path === '/' || to.path === '')) {
    const routeQuery = { xero: oauth.xero, tab: oauth.tab }
    if (oauth.message) routeQuery.message = oauth.message
    const hasToken = !!(typeof localStorage !== 'undefined' && localStorage.getItem('token'))
    if (!hasToken) {
      try {
        sessionStorage.setItem('smardie_xero_oauth', JSON.stringify(routeQuery))
      } catch (e) {
        /* ignore */
      }
      next()
      return
    }
    next({ path: '/settings/account', query: routeQuery, replace: true })
    return
  }
  
  const isAuthenticated = store.getters['user/isAuthenticated']
  
  // Check if route requires authentication
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
    return
  }
  
  // If authenticated but no profile loaded yet, fetch it first
  if (isAuthenticated && !store.getters['user/getProfile']) {
    try {
      // On public routes (e.g. /verify, /login), a stale token must not trigger the global
      // axios 401 handler + /login redirect — user has no session until they verify.
      const response = await axios.get('/api/auth/user', {
        _publicRouteProbe: !to.meta.requiresAuth
      })
      if (response.data.user) {
        store.commit('user/setUserProfile', response.data.user)
        store.commit('user/setUserSubscription', response.data.subscription)
      }
    } catch (error) {
      console.error('Failed to fetch user profile:', error)
      store.commit('user/setLoggedOut')
      localStorage.removeItem('token')
      delete axios.defaults.headers.common['Authorization']
      // Protected routes: send to login. Public routes (verify email link, etc.): stay on target
      if (to.meta.requiresAuth) {
        next('/login')
        return
      }
      next()
      return
    }
  }
  
  const isPlatformAdmin = store.getters['user/isPlatformAdmin']
  const pendingAccountSelection = store.getters['user/pendingAccountSelection']
  const isSelectAccountRoute = to.path === '/select-account'
  const isInviteAcceptRoute = to.path.startsWith('/invite/accept')

  if (isAuthenticated && pendingAccountSelection && !isSelectAccountRoute && !isInviteAcceptRoute) {
    next('/select-account')
    return
  }

  // Smardie platform admin: only admin-only routes + settings (no quotes app)
  if (isAuthenticated && isPlatformAdmin) {
    if (to.meta.adminOnly) {
      next()
    } else if (to.path.startsWith('/settings/')) {
      next()
    } else {
      next('/settings/category')
      return
    }
  }

  if (to.meta.adminOnly && !isPlatformAdmin) {
    next('/')
    return
  }

  // Onboarding: new users must complete onboarding before accessing app
  const profile = store.getters['user/getProfile']
  const onboardingCompleted = profile && profile.onboarding_completed === true
  const isOnboardingRoute = to.path.startsWith('/onboarding')

  const xeroConnectedReturn =
    to.path === '/settings/account' && to.query && String(to.query.xero) === 'connected'
  if (isAuthenticated && !isPlatformAdmin && !onboardingCompleted && !isOnboardingRoute) {
    if (!xeroConnectedReturn) {
      next('/onboarding/welcome')
      return
    }
  }
  if (isAuthenticated && onboardingCompleted && isOnboardingRoute) {
    next('/')
    return
  }

  // Trial/subscription: if no active subscription, only allow pricing and payment pages
  if (isAuthenticated && !isPlatformAdmin && onboardingCompleted && to.meta.requiresAuth) {
    const isPricingPage = to.path === '/settings/plans'
    const isPaymentPage = to.path === '/settings/payment'
    const isXeroOAuthReturn =
      to.path === '/settings/account' && to.query && String(to.query.xero) === 'connected'
    try {
      const res = await axios.get('/subscription/status')
      store.commit('setSubscriptionStatus', res.data)
      if (res.data.must_upgrade && !isPricingPage && !isPaymentPage && !isXeroOAuthReturn) {
        next('/settings/plans')
        return
      }
    } catch (e) {
      // allow navigation if status fetch fails (e.g. no subscription yet)
      store.commit('setSubscriptionStatus', null)
    }
  }

  next()
})

export default router
